module.exports = __webpack_public_path__ + "img/icon_tips@3x.19d2f678.png";